var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.587.507a1.372 1.372 0 0 1-.094 1.937c-2.714 2.462-4.615 4.55-6.196 7.018-1.587 2.477-2.89 5.395-4.34 9.56a1.371 1.371 0 0 1-2.28.504L.445 13.098a1.371 1.371 0 1 1 1.97-1.91l4.704 4.852c1.214-3.238 2.416-5.79 3.87-8.058C12.743 5.24 14.83 2.97 17.65.412a1.372 1.372 0 0 1 1.937.095Z",
  fill: "#3A434A"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgCheck;